export default "__VITE_ASSET__21f5f69a__"